import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-5" }
const _hoisted_3 = { class: "d-flex align-items-center landingSubtitle" }
const _hoisted_4 = { class: "pb-2" }
const _hoisted_5 = { class: "fw-bolder d-flex align-items-center text-dark groupLabel" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "la la-plus" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menores = _resolveComponent("Menores")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatosMenorModal = _resolveComponent("DatosMenorModal")!
  const _component_DatosMenorSimpleModal = _resolveComponent("DatosMenorSimpleModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("paso3")), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t("DatosMenoresGroupLabel")), 1)
      ]),
      _createElementVNode("div", {
        class: "fs-6 pb-2 textoJustificado",
        innerHTML: _ctx.$t('DatosMenoresText')
      }, null, 8, _hoisted_6),
      _createVNode(_component_Menores, {
        list: _ctx.list,
        onItemTap: _ctx.edit
      }, null, 8, ["list", "onItemTap"]),
      _createVNode(_component_ErrorMessage, {
        name: "menores",
        class: "fv-plugins-message-container invalid-feedback"
      }),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-color-primary btn-active-light-primary text-uppercase my-5",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.create && _ctx.create(...args)))
        }, [
          _hoisted_7,
          _createTextVNode(_toDisplayString(_ctx.$t("DatosMenoresAddMenorBtn")), 1)
        ])
      ])
    ]),
    _createVNode(_component_DatosMenorModal, {
      callback: _ctx.saveOrUpdate,
      model: _ctx.menorData,
      "onUpdate:model": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.menorData) = $event)),
      title: _ctx.isCreate ? _ctx.$t('menoresModalTitleAdd') : _ctx.$t('menoresModalTitleEdit'),
      id: "iam_modal_datos_menor"
    }, null, 8, ["callback", "model", "title"]),
    _createVNode(_component_DatosMenorSimpleModal, {
      callback: _ctx.saveOrUpdate,
      model: _ctx.menorData,
      "onUpdate:model": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.menorData) = $event)),
      title: _ctx.isCreate ? _ctx.$t('menoresModalTitleAdd') : _ctx.$t('menoresModalTitleEdit'),
      id: "iam_modal_datos_menor_simple"
    }, null, 8, ["callback", "model", "title"])
  ], 64))
}